import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProcessSelectionComponent } from './component/process-selection.component';
import { TapableTerminalCardModule } from 'src/tmc-common/widgets/terminal/tabbable-terminal-card/tapable-terminal-card.module';
import { CenteredScrollableContentModule } from 'src/tmc-common/widgets/terminal/centered-scrollable-content/centered-scrollable-content.module';



@NgModule({
  declarations: [
    ProcessSelectionComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    DictionaryModule,
    TapableTerminalCardModule,
    ApplicationClientCommonModule,
    CenteredScrollableContentModule,
    CommonTranslationModule,
    FormsModule,
    ReactiveFormsModule

  ]
})
export class ProcessSelectionModule { }
